import React from "react";
import moment from "moment";
import AddNewSvg from "./../PatientDashboardIcons/addNew.svg";
import NHSIcon from "./../PatientDashboardIcons/nhs.svg";
import BeforeIcon from "./../PatientDashboardIcons/before.svg";
import DotIcon from "./../PatientDashboardIcons/dot.svg";
import MenuSvg from "./../../../pages/Dashboard/OverviewTab/OverviewIcons/menu.svg";
import { RxCheckCircled } from "react-icons/rx";
import useTitanApp from "../../../hooks/useTitanApp";
import Skeleton from "@mui/material/Skeleton";
import { useNavigate } from "react-router-dom";
import { setPatientInfoTab } from "../../../dispatchers/appDispatchers";
import { setConsultationId } from "../../../dispatchers/patientDispatchers";
import { setShowNHS111ReferralTab } from "@/dispatchers/pharmacyServiceDispatchers";

export default function Appointments() {
  const navigate = useNavigate();
  const { patientState, appState } = useTitanApp();
  const { darkMode } = appState || {};
  const { currentPharmacy } = appState || {};
  const { patientAppointmentListLoader, patientAppointmentList } = patientState;
  const handleAppointmentClick = (appointment) => {
    setPatientInfoTab(1);
    setConsultationId(appointment.id);
    setShowNHS111ReferralTab(false);
    navigate(
      `/pharmacy/patientconsultation/${currentPharmacy.teamPharmacyID}/${appointment?.patientID}/${appointment?.id}`,
    );
  };
  const sortedPatientAppointmentsList = [
    ...(patientAppointmentList || []),
  ].sort((a, b) => {
    const aDateTime = moment(
      `${a.appointmentDate} ${a.appointmentTime.split(" - ")[0]}`,
      "ddd DD MMMM h:mma",
    );
    const bDateTime = moment(
      `${b.appointmentDate} ${b.appointmentTime.split(" - ")[0]}`,
      "ddd DD MMMM h:mma",
    );
    return bDateTime - aDateTime; // descending
  });
  return (
    <React.Fragment>
      <div className="tasks_header header_appointment upcoming_appntmnt">
        <h3 className="pharmacy_header_name">Upcoming Appointments</h3>
        {/* <AddNewSvg /> */}
      </div>

      <div
        className="patient-detail-appointments"
        id="patient-appointments-wrapper"
      >
        {patientAppointmentListLoader ? (
          <div className="appointment-skeleton-wrapper">
            {[...Array(3)].map((_, i) => (
              <Skeleton
                key={i}
                sx={{
                  bgcolor: darkMode ? "grey.800" : "",
                  width: "100%",
                  height: "70px",
                  borderRadius: "16px",
                  marginBottom: "10px",
                }}
                variant="rounded"
              />
            ))}
          </div>
        ) : patientAppointmentList.length > 0 ? (
          <div className="wrapper">
            {sortedPatientAppointmentsList.map((upcomingAppointment, index) => (
              <div
                className="appointment"
                key={index}
                onClick={() => handleAppointmentClick(upcomingAppointment)}
              >
                <div className="left">
                  <BeforeIcon className="beforeIcon" />
                  <NHSIcon />
                  <div className="appointment-info">
                    <p className="name">{upcomingAppointment.serviceName}</p>
                    <div className="dateandtime">
                      <p className="date">
                        {upcomingAppointment.appointmentDate}
                      </p>
                      <DotIcon />
                      <p className="time">
                        {upcomingAppointment.appointmentTime}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="right">
                  <div className="status">
                    <RxCheckCircled className="icons-color" />
                    <p>{upcomingAppointment.appointmentStatus}</p>
                  </div>
                  <MenuSvg className="icons-color" />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="no-appointments">Patient has No Appointments</p>
        )}
      </div>
    </React.Fragment>
  );
}
